import { ensureScriptTag } from "@/utils/scriptHelper";
import { useCallback, useState } from "react";
import {showFirstLayer } from '@s-group/react-usercentrics'
import Button from "../../components/Button";
import SettingIcon from "@/assets/icon/settings.svg";


declare global {
  interface Window {
    UC_UI: any;
  }
}

type SocialMediaFacebookElementProps = {
  id: string,
  url: string,
  isConsentGiven: boolean,
  idConsentInitialized: boolean
};

export function SocialMediaFacebookElement(
  {
    id,
    url,
    isConsentGiven,
    idConsentInitialized
  }: SocialMediaFacebookElementProps) {
    const [width, setWidth] = useState(0);
    const [fbPostHeight, setFbPostHeight] = useState(0);

    const ref = useCallback((element: HTMLDivElement) => {
      if(element) {
        if(idConsentInitialized && isConsentGiven && element && width > 0) {
          if ((window as any).FB) {
            (window as any).FB.XFBML.parse(element);
          } else {
            ensureScriptTag({src: 'https://connect.facebook.net/de_DE/sdk.js', async: true, defer: true, crossOrigin: "anonymous", referrerPolicy: "no-referrer"});
            const oldFbAsyncInit = (window as any).fbAsyncInit;
            (window as any).fbAsyncInit = function () {
              if(oldFbAsyncInit) {
                oldFbAsyncInit();
              } else {
                (window as any).FB.init({
                  xfbml: false,
                  version: 'v20.0'
                });
              }
              (window as any).FB.XFBML.parse(element);
            };
          }
        }

        const resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
              // Assuming the element's box size is border-box
              setWidth(entry.contentRect.width);
          }
      });

      if (element) {
          resizeObserver.observe(element);
      }

      return () => {
          if (element) {
              resizeObserver.unobserve(element);
          }
      };
      }
    }, [width, isConsentGiven, idConsentInitialized])

    const fbPostRef = useCallback((element: HTMLDivElement) => {
      if(element) {
        const resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
              // Assuming the element's box size is border-box
              setFbPostHeight(entry.contentRect.height);
          }
      });

      if (element) {
          resizeObserver.observe(element);
      }

      return () => {
          if (element) {
              resizeObserver.unobserve(element);
          }
      };
      }
    }, [width])

  const scaleFactor = width/350;
  return <>
    {isConsentGiven && idConsentInitialized &&
    <div 
      id={id} 
      ref={ref} 
      className="bg-gray-150 rounded-sm max-w-[750px] min-h-24 overflow-hidden"
      style={{
        height: (width <= 350 && fbPostHeight > 0) ? `${fbPostHeight * scaleFactor}px` : undefined
      }}
      >
        <div
          className="origin-top-left bg-gray-50"
          style={{
            transform: (width < 350) ? `scale(${scaleFactor})` : undefined
          }}
        >
          <div ref={fbPostRef} className="fb-post" data-width={`${Math.min(Math.max(350,width), 750)}`} data-href={url}></div>

        </div>
    </div>
  }
  {!isConsentGiven && idConsentInitialized && 
    <div className="bg-gray-150 rounded-lg p-4 py-8 flex flex-col text-center ">
      <div className="font-semibold">Externen Inhalt von Facebook freigeben</div>
        Wir benötigen deine Zustimmung, um externe Inhalte von Facebook anzuzeigen.
      <div>
        <Button className="w-auto inline" color="link-secondary"  onClick={showFirstLayer}><SettingIcon className="w-4 h-4 mr-blank" /> Einstellungen bearbeiten</Button>
      </div>
    </div>
  }
  
  </>
}

